import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import { GpsMonitor } from "./components/Gps/GpsMonitor";
import { TrackPlayback } from "./components/Gps/TrackPlayback";
import { DeviceManagement } from "./components/Devices/DeviceManagement";
import { UserManagement } from "./components/Users/UserManagement";
import { GroupManagement } from "./components/Groups/GroupManagement";
import { EmployeeManagement } from "./components/Employees/EmployeeManagement";
import { PermissionManagement } from "./components/Permissions/PermissionManagement";
import { ConnectionLogPage } from "./components/Logs/ConnectionLogPage";
import { AlarmLogPage } from "./components/Logs/AlarmLogPage";
import { SystemOperationLogPage } from "./components/Logs/SystemOperationLogPage";
import { GGGManagerPage } from "./components/GGGManager/GGGManagerPage";
import { Login } from "./components/Auth/Login";
import { ProtectedRoute } from "./components/Auth/ProtectedRoute";
import { RoleRoute } from "./components/Auth/RoleRoute";
import { PermissionKeys } from "./permissions";

const AppRoutes = [
  {
    index: true,
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    )
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/counter',
    element: (
      <ProtectedRoute>
        <Counter />
      </ProtectedRoute>
    )
  },
  {
    path: '/fetch-data',
    element: (
      <ProtectedRoute>
        <FetchData />
      </ProtectedRoute>
    )
  },
  {
    path: '/gps-monitor',
    element: (
      <ProtectedRoute>
        <GpsMonitor />
      </ProtectedRoute>
    )
  },
  {
    path: '/track-playback',
    element: (
      <ProtectedRoute>
        <TrackPlayback />
      </ProtectedRoute>
    )
  },
  {
    path: '/devices',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.DeviceView}>
        <DeviceManagement />
      </RoleRoute>
    )
  },
  {
    path: '/users',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.UserView}>
        <UserManagement />
      </RoleRoute>
    )
  },
  {
    path: '/groups',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.GroupView}>
        <GroupManagement />
      </RoleRoute>
    )
  },
  {
    path: '/employees',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.EmployeeView}>
        <EmployeeManagement />
      </RoleRoute>
    )
  },
  {
    path: '/permissions',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.PermissionManage}>
        <PermissionManagement />
      </RoleRoute>
    )
  },
  {
    path: '/connection-logs',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.ConnectionLogView}>
        <ConnectionLogPage />
      </RoleRoute>
    )
  },
  {
    path: '/alarm-logs',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.AlarmLogView}>
        <AlarmLogPage />
      </RoleRoute>
    )
  },
  {
    path: '/system-operation-logs',
    element: (
      <RoleRoute allowRoles={["Admin", "CustomerAdmin"]} requiredPermission={PermissionKeys.SystemOpLogView}>
        <SystemOperationLogPage />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="overview" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/services',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="services" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/clients',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="clients" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/commands',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="commands" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/firmware',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="firmware" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/alarms',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="alarms" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/config',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="config" />
      </RoleRoute>
    )
  },
  {
    path: '/ggg-manager/logs',
    element: (
      <RoleRoute allowRoles={["Admin"]} requiredPermission={PermissionKeys.GggManagerView}>
        <GGGManagerPage section="logs" />
      </RoleRoute>
    )
  }
];

export default AppRoutes;
